import { get } from '../lib/axios'
import { FeatureToggleConfigurationResponse } from './configuration'
import { useQuery } from '@tanstack/react-query'

const fetchFeatureToggleConfiguration = async () => {
  return get<FeatureToggleConfigurationResponse>('/api/configuration/feature-toggle')
}

export const getFeatureToggleConfiguration = () => {
  return useQuery({
    staleTime: Infinity,
    queryKey: ['featureToggleConfiguration'],
    queryFn: () => fetchFeatureToggleConfiguration()
  })
}